import { z } from 'zod';
export const auditLogQuerySchema = z.object({
    user_id: z.string().uuid().optional(),
    action: z.string().max(100).optional(),
    resource_type: z.string().max(100).optional(),
    date_from: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Formato: YYYY-MM-DD').optional(),
    date_to: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Formato: YYYY-MM-DD').optional(),
    limit: z.coerce.number().int().min(1).max(100).optional(),
    offset: z.coerce.number().int().min(0).optional(),
});
//# sourceMappingURL=audit-log.schema.js.map